import { ReactComponent as PepperIcon } from './pepper.svg';

export default PepperIcon;
